import { useFetchSilaeAddonDetails } from './Addon/hooks/useFetchSilaeAddonDetails'
import { useFetchSilaeConfiguration } from './Configuration/hooks/useFetchSilaeConfiguration'
import { useFetchSilaeConfigurationListRecord } from './Configuration/hooks/useFetchSilaeConfigurationListRecord'
import { useSilaeConfirmation } from './Confirmation/hooks/useSilaeConfirmation'
import { useSilaeDismissPromotion } from './Confirmation/hooks/useSilaeDismissPromotion'
import { useFetchSilaeCredential } from './Credentials/hooks/useFetchSilaeCredential'
import { usePostSilaeCredential } from './Credentials/hooks/usePostSilaeCredential'
import { usePutSilaeCredential } from './Credentials/hooks/usePutSilaeCredential'
import { useFetchSilaeLocations } from './Locations/hooks/useFetchSilaeLocations'
import { usePutSilaeLocations } from './Locations/hooks/usePutSilaeLocations'
import { useFetchSilaeSynchronizedMembers } from './Synchronization/hooks/useFetchSilaeSynchronizedMembers'
import { useUpdateSilaeSync } from './Synchronization/hooks/useUpdateSilaeSync'

class SilaeService {
  addon = {
    useFetch: useFetchSilaeAddonDetails
  }

  locations = {
    useFetch: useFetchSilaeLocations,
    putLocations: usePutSilaeLocations
  }

  synchronization = {
    useFetch: useFetchSilaeSynchronizedMembers,
    updateSilaeSync: useUpdateSilaeSync
  }

  configuration = {
    useFetchConfiguration: useFetchSilaeConfiguration,
    useFetchListRecord: useFetchSilaeConfigurationListRecord
  }

  confirmation = {
    useConfirmation: useSilaeConfirmation,
    useDismissPromotion: useSilaeDismissPromotion
  }

  credentials = {
    postCredential: usePostSilaeCredential,
    useFetchCredential: useFetchSilaeCredential,
    putSilaeCredential: usePutSilaeCredential
  }
}

export const silaeService = new SilaeService()
